<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card class="mb-6" :title="$t('AddPlan') | ToUppercase">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full">
                        <small>{{$t('DateFrom') |ToUppercase}}</small><br>
                        <datepicker v-model="dateFrom"></datepicker>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full">
                        <small>{{$t('DateTo') |ToUppercase}}</small><br>
                        <datepicker v-model="dateTo"></datepicker>
                    </div>
                </div>
                <small>{{$t('Explanation') |ToUppercase}}</small><br>
                <vs-textarea v-model="explanation" />

                <div class="mt-6">
                    <vs-button class="mr-2" @click="addHolidayPlan()">{{ $t("Add") | ToUppercase }}</vs-button>
                    <vs-button @click="$router.go(-1)">{{ $t("Back") | ToUppercase }}</vs-button>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                dateFrom: null,
                dateTo: null,
                explanation: '',
            };
        },
        methods: {
            addHolidayPlan() {
                if(this.dateFrom > this.dateTo) {
                    this.$vs.notify({
                        text: "Neveljaven datum",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                    return;
                }

                this.$vs.loading();
                
                const thisIns = this;
                this.$http.post("/holiday-plan/add", {
                    date_from: thisIns.dateFrom,
                    date_to: thisIns.dateTo,
                    explanation: thisIns.explanation,
                }).then(function () {
                    thisIns.$vs.notify({
                        text: "Najava dopusta shranjena",
                        color: "success",
                    });
                    thisIns.$router.push('/holiday-plan/all');
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri shranjevanju",
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                    });
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            
        },
    };
</script>